import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Country } from "../models/country.model";
import { GraphQLService } from "./graphql.service";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";

import countriesQuery from 'src/app/graphql/queries/countries.query.graphql'

@Injectable()
export class CountryService extends GraphQLService<Country> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  deliverable(): Observable<Country[]> {
    return this.findAll(countriesQuery)
  }

}
